import React, { useMemo } from "react";
import {
  Flex,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { Pagination } from "antd";

const TransactionList = ({
  title = "Transactions",
  columnsData = [],
  tableData = [],
  pagination,
  loading = false,
  onPageChange,
}) => {
  const hasData = tableData && tableData.length > 0;
  const columns = useMemo(() => columnsData, [columnsData]);
  const headerColor = useColorModeValue("gray.400", "gray.200");
  const rowColor = useColorModeValue("gray.700", "gray.100");
  const emptyColor = useColorModeValue("gray.500", "gray.300");
  const cardBg = useColorModeValue("white", "navy.800");
  const borderColor = useColorModeValue("gray.100", "whiteAlpha.100");

  const renderCell = (column, row) => {
    if (typeof column.render === "function") {
      return column.render(row);
    }

    if (column.accessor) {
      const value = row[column.accessor];
      return value === null || value === undefined || value === ""
        ? "-"
        : value;
    }

    return "-";
  };

  const handlePageChange = (page) => {
    if (typeof onPageChange === "function") {
      onPageChange(page);
    }
  };

  return (
    <Flex
      direction="column"
      w="100%"
      bg={cardBg}
      borderRadius="16px"
      boxShadow="0px 18px 40px -12px rgba(13, 39, 80, 0.12)"
    >
      <Flex
        align={{ base: "flex-start", md: "center" }}
        justify="space-between"
        w="100%"
        px="24px"
        py="18px"
        borderBottom="1px solid"
        borderColor={borderColor}
      >
        <Text color={rowColor} fontSize="xl" fontWeight="600">
          {title}
        </Text>
      </Flex>

      <Table variant="simple" color="gray.500">
        <Thead>
          <Tr>
            {columns.map((column) => (
              <Th
                key={column.key || column.accessor || column.Header}
                borderColor="transparent"
              >
                <Text
                  fontSize="xs"
                  textTransform="uppercase"
                  color={headerColor}
                >
                  {column.Header}
                </Text>
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {loading && (
            <Tr>
              <Td colSpan={columns.length || 1}>
                <Flex justify="center" align="center" py={8}>
                  <Spinner size="sm" />
                </Flex>
              </Td>
            </Tr>
          )}

          {!loading && hasData
            ? tableData.map((row) => (
                <Tr
                  key={
                    row.id || row.transfer_id || `${row.created}-${row.amount}`
                  }
                >
                  {columns.map((column) => (
                    <Td
                      key={column.key || column.accessor || column.Header}
                      color={rowColor}
                    >
                      {renderCell(column, row)}
                    </Td>
                  ))}
                </Tr>
              ))
            : null}

          {!loading && !hasData && (
            <Tr>
              <Td colSpan={columns.length || 1}>
                <Flex
                  direction="column"
                  align="center"
                  justify="center"
                  py={10}
                >
                  <Text color={emptyColor} fontWeight="500">
                    No transactions available.
                  </Text>
                </Flex>
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>

      {pagination && (
        <Flex justify="center" align="center" px="22px" py="16px" w="100%">
          <Pagination
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            onChange={handlePageChange}
            showSizeChanger={false}
            showQuickJumper={false}
            showTotal={false}
          />
        </Flex>
      )}
    </Flex>
  );
};

export default TransactionList;